(function() { module.exports = window["wp"]["hooks"]; }());